export const LOGIN = 'PROFILE/LOGIN';
export const LOGOUT = 'PROFILE/LOGOUT';

export const login = (profile) => ({
  type: LOGIN,
  profile: profile
});

export const logout = () => ({
  type: LOGOUT
});

const initialState = {
  isLogin: false,
  profile: null
}

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        isLogin: true,
        profile: action.profile
      };
    case LOGOUT:
      return {
        ...state,
        isLogin: false,
        profile: null
      }
    default:
      return state;
  }
}

export default profileReducer;